(function() {
    'use strict';

    angular.module('caffeprint')
        .controller('NavigationController', NavigationController);

    NavigationController.$inject = ['$state', 'userAuthService', 'notificationSrvc', 'userStorageSrvc', 'checkModelPermissionsSrvc'];

    function NavigationController($state, userAuthService, notificationSrvc, userStorageSrvc, checkModelPermissionsSrvc) {
        var self = this;

        self.logout = userAuthService.logout;
        self.name = '';

        self.isHasPermission = isHasPermission;
        self.isSectionHasViewPermission = isSectionHasViewPermission;

        activate();

        function activate() {
            getName();
        }

        function getName() {
            var user = userStorageSrvc.getUser();
            if (user) {
                self.name = user.first_name + ' ' + user.last_name;
            }
        }

        function isHasPermission(stateName) {
            var state = $state.get(stateName);

            if (state.data && state.data.modelPermission) {
                return !checkModelPermissionsSrvc.isDenied(
                    state.data.modelPermission);
            } else {
                return true;
            }
        }

        function isSectionHasViewPermission(className) {
            return angular.element('.' + className).find('li').length !== 0;
        }
    }
})();
